const API_BASE_URL = "https://qaibizapi.perennialdigitals.com/";
// Alert api
const ALERT_API_BASE_URL = "https://pchealth.ibizaccounts.in/";//process.env.REACT_ALERT_API_BASE_URL;
// Image url
const IMAGE_URL_IBIZ = "http://files-test.perennialdevelopers.in/";

// core/modals/inventory
const GET_DDL = "Admin/getDDl";
const DELETE_PO_PRODUCT = "Inventory/DelPOProduct";
const DELETE_INDENT = "Inventory/DelIndent";
const GET_LATE_INDENT_REQ = "Inventory/GetLateIndentsReqs";
const INSERT_LATE_INDENT_REQ = "Inventory/InsertLateIndentReq";
const UPDATE_LATE_INDENT_REQ = "Inventory/UpdateLateIndentReq";
const GET_BARCODE_TYPE = "Product/GetBarcodeType";
const GET_SUPPLIER_PAYMENTS_PENDING = "Inventory/GetSupplierPendingPaymnts";
const GET_SUPPLIER_PAYMENTS_VIEW = "Inventory/GetSupplierPaymntsVIEW";
const GET_INDENT_BTN_STATUS = "admin/checkSubmitIndent";
const GET_DOCS = "Admin/getDOCS";
const GET_HEADER_NOTIFYS = "Misc/getNotifications";
const RECEIVE_LOCAL_INDENT_STOCK = "Inventory//ReceiveLocalStock";
const UPLOAD_FILES = "Admin/UploadFILES";
const CHANGE_PASSWORD = "Auth/ChangePassword";
const GET_MENU = "Admin/getmenu";
const VIEW_COMBO_PRODUCTS = "Product/viewComboProducts";
const PRINT_INVOICE = "Inventory/PrintPurchaseInvoice";
const UPDATE_STORE_SECURITY = "Admin/UPDTStoreSecurity";
const INSERT_BRANDS = "Product/InsertBrands";
const PRODUCT_IMAGE_UPLOAD = "Product/UploadProductIMG";
const GET_STORE_SECURITY = "Admin/GetStoreSecurity";
const INSERT_CATEGORY = "Product/InsertCategories";
const INSERT_SUB_CATEGORY = "Product/InsertSubCategories";
const INSERT_UNIT = "Settings/InsertUnits";
const UPDATE_STORE = "Settings/UpdateStores";
const INSERT_STORE = "Settings/InsertStores";
const INSERT_VARIANT = "Settings/InsertVariantTypes";
const UPDATE_BRAND = "Product/UpdateBrands";
const UPDATE_CATEGORY = "Product/UpdateCategories";
const UPDATE_USERMENU = "Admin/UpdateUserMenu";
const UPDATE_UNIT = "Settings/UpdateUnits";
const UPDATE_VARIANT = "Settings/UpdateVariantTypes";
const GET_USER_PERMISSIONS = "Admin/UserPermissions";
const GET_ORDERS = "Billing/getOrders";
const GET_ORDERS_BY_ID = "Billing/getOrdersById";
const INSERT_ORDERS = "Billing/SaveOrders";
const UPDATES_INDENT_STATUS = "Inventory/UpdateIndentStatus";
const GET_USERS = "Admin/getUsers";
const GET_STAFF = "Settings/GetStaff";
const INSERT_STAFF = "Settings/InsertStaff";
const UPDATE_STAFF = "Settings/UpdateStaff";
const DELETE_STAFF = "Settings/DelStaff";
const INSERT_USER = "Admin/InsertUsers";
const UPDATE_USER = "Admin/UpdateUsers";
const GET_REPORT_FILTERS = "report/getreporthead";
const GET_REPORT_DATA = "report/getreport";
const GET_TAXES_DATA = "Settings/GetTaxes";

//modals/peoples,purchases
const UPDATE_SUPPLIER = "Inventory/InsertSuppliers";
const GET_SUPPLIER_DETAILS = "Inventory/GetSupplierDetails";
const INSERT_SUPPLIER = "Inventory/InsertSuppliers";
const DELETE_SUPPLIER = "Inventory/DelSuppliers";
const INSET_CUSTOMER = "Customer/InsertCustomer";
const GET_COMBO_DDL = "Product/getComboDDl";
const GET_COMBO_PRODUCTS = "Product/GetComboProduct";
const INSERT_COMBO_PRODUCT = "Product/InsertComboProducts";

//modals/purchases
const GET_PROD = "Product/GetProducts";
const GET_STORE = "Settings/getStores";
const INSERT_PURCHASE_REQ = "Inventory/InsertPurchaseRequest";
const INSERT_PURCHASE_ORDEDR = "Inventory/InsertPurchaseOrder";
const PO_SEND_TO_SUPPLIER = "Inventory/POSendToSupplier";
const GET_CATEGORIES = "Product/getCategories";
const GET_CUSTOMERS = "Customer/getCustomer";
const GET_VARIANT = "Settings/getVariantTypes";
const PROD_DOWNLD_EXCEL = "Productsdownld-excel";
const GET_PURCHASE_REQ_DETAILS = "Inventory/getPurchaseRequestDetails";
const GET_PO_REQ_BY_ID = "Inventory/GetPRById";
const GET_PO_RECEIVED_BY_ID = "Inventory/GetPOReceivedByID";
//modals/stocks
const GET_USER_STORES = "Settings/getUserStores";
const INSERT_POS_TERMINALS = "Settings/InsertPosTerminals";
const UPDATE_POS_TERMINALS = "Settings/UpdatePosTerminals";
const GET_POS_TERMINALS = "Settings/getPosTerminals";
const GET_CATEGORIES_ITEMS = "POS/GetCategoryItems";
const GET_METAL_RATES = "Settings/GetMetalRates";
const GET_ORDER_VIEW = "POS/GetOrderView";
const GET_TRANSFER_PROD = "product/getTransferProducts";
const GET_STOCK_TRANSFER_BY_ID = "Inventory/getStockTransferById";
const INSERT_TRANSFER_STOCK = "Inventory/ADDStockTransfer";
// const INSERT_TRANSFER_STOCK = 'Inventory/InsertStockTransfer';
const INSERT_TRANSFER_STOCK_DETAILS = "Inventory/InsertTransferStockDetails";
const UPDATE_TRANSFER_STOCK_STATUS = "Inventory/UpdateTransferStockStatus";
// feature-module/dashboard
const GET_DASHBOARD_COUNT = "Dashboard/getDashboardCounts";
const GET_DASHBOARD_TABLES_DATA = "Dashboard/InventoryDashboard";
const GET_STORE_DASHBOARD = "Dashboard/StoreDashboard";
const GET_ACCOUNTS_DASHBOARD = "Dashboard/AccountsDashboard";
const GET_TOP_SALES = "Dashboard/getTopSales";
//feature-module/financeAccounts
const GET_EXPENSE_TYPE = "Settings/getExpenseTypes";
const GET_EXPENSE = "Misc/getExpenses";
const INSERT_EXPENSE = "Misc/InsertExpenses";
//feature-module/inventory
const GET_SUB_CATEGORIES = "Product/getSubCategories";
const INSERT_PROD = "Product/InsertProducts";
const INSERT_STORE_PROD = "Product/InsertStoreProducts";
const GET_BRAND = "Product/getBrands";
const DEL_BRAND = "Product/DelBrands";
const DEL_CATEGORY = "Product/DelCategories";
const UPDATE_SUB_CATEGORIES = "Product/UpdateSubCategories";
const GET_EXPIRED = "REPORTS";
const GET_VSTORE_PROD = "Product/GetStoreProducts";
const GET_VSTORE_POS_PROD = "POS/GetPOSStoreProducts";
const DEL_SUB_CATEGORY = "Product/DelSubCategories";
const GET_UNITS = "Settings/getUnits";
const DEL_UNITS = "Settings/DeleteUnits";
//pages/login
const SIGN_IN_DETAILS = "Auth/SignIn";
const GET_INVOICE_PAYMENTS = "Inventory/GetPOpayments";
const GET_PAYMENTS_TYPES = "Settings/getPaymentTypes";
const ADD_PAYMENTS = "Inventory/POpayments";

//pages/purchases
const GET_SUPPLIERS = "Inventory/GetSuppliers";
const GET_STOCK_INDENT = "Inventory/getStockIndent";
const GET_STOCK_INDENT_LIST = "Inventory/getIndentList";
const GET_APPROVED_INDENTS_BY_STORE = "Inventory/getApprovedIndentByStore";
const INSERT_STOCK_INDENT = "Inventory/InsertStockIndent";
const DOWNLD_EXCEL = "Excels/download-excel";
const PRODUCT_DOWNLOD_EXCEL = "Excels/Productdownload-excel";
const PRODUCT_UPLOAD_EXCEL = "Excels/AddProductupload-excel";
const PRODUCT_EDIT_DOWNLOD_EXCEL = "Excels/UPDTProductdownload-excel";
const PRODUCT_EDIT_UPLOAD_EXCEL = "Excels//EditProductupload-excel";
const UPLOAD_EXCEL = "Excels/Indentupload-excel";
const PO_UPLOAD_EXCEL = "Excels/POupload-excel";
const GET_PURCHASE_REQ = "Inventory/GetPurchaseRequest";
const GET_APPROVED_INDENTS = "Inventory/getApprovedIndent";
const GET_CONSOLIDATED_INDENTS = "Inventory/getConsolidatedIndents";
const GET_PO = "Inventory/GetPO";
const GET_INVOICES = "Inventory/GetInvoices";
const GET_TRANSFER_STOCK = "Inventory/getStockTransferList";
const INSERT_PURCHASE_INVOICE = "Inventory/InsertPurchaseInvoice";
const GET_PO_BY_ID = "Inventory/GetPOById";
const GET_SUP_STO_DATA = "Inventory/GetSupStoreByPOId";
const GET_TRANSFER_STOCK_PDF = "Inventory/getStockTransferPdf";
const GET_INVENTORY_PRODUCTS = "Inventory/GetInventoryProducts";
const GET_DELIVERY_CHALLAN = "Inventory/GetDeliveryChallans";
const INSERT_INVENTORY_PRODUCT = "Inventory/InsertInventoryProduct";

export {
  API_BASE_URL,
  ALERT_API_BASE_URL,
  IMAGE_URL_IBIZ,
  GET_DDL,
  DELETE_PO_PRODUCT,
  DELETE_INDENT,
  INSERT_LATE_INDENT_REQ,
  UPDATE_LATE_INDENT_REQ,
  GET_BARCODE_TYPE,
  GET_LATE_INDENT_REQ,
  GET_TRANSFER_STOCK_PDF,
  GET_INVENTORY_PRODUCTS,
  INSERT_INVENTORY_PRODUCT,
  GET_DELIVERY_CHALLAN,
  GET_SUPPLIER_PAYMENTS_PENDING,
  GET_SUPPLIER_PAYMENTS_VIEW,
  GET_INDENT_BTN_STATUS,
  GET_DOCS,
  GET_HEADER_NOTIFYS,
  RECEIVE_LOCAL_INDENT_STOCK,
  UPLOAD_FILES,
  CHANGE_PASSWORD,
  GET_MENU,
  VIEW_COMBO_PRODUCTS,
  PRINT_INVOICE,
  UPDATE_STORE_SECURITY,
  INSERT_BRANDS,
  PRODUCT_IMAGE_UPLOAD,
  GET_STORE_SECURITY,
  INSERT_CATEGORY,
  INSERT_SUB_CATEGORY,
  INSERT_UNIT,
  UPDATE_STORE,
  INSERT_STORE,
  INSERT_VARIANT,
  UPDATE_BRAND,
  UPDATE_CATEGORY,
  UPDATE_USERMENU,
  UPDATE_UNIT,
  UPDATE_VARIANT,
  GET_USER_PERMISSIONS,
  GET_ORDERS,
  GET_ORDERS_BY_ID,
  INSERT_ORDERS,
  UPDATES_INDENT_STATUS,
  GET_USERS,
  GET_STAFF,
  INSERT_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
  INSERT_USER,
  UPDATE_USER,
  GET_REPORT_FILTERS,
  GET_REPORT_DATA,
  GET_TAXES_DATA,
  GET_SUPPLIER_DETAILS,
  UPDATE_SUPPLIER,
  INSERT_SUPPLIER,
  DELETE_SUPPLIER,
  INSET_CUSTOMER,
  GET_COMBO_DDL,
  GET_COMBO_PRODUCTS,
  INSERT_COMBO_PRODUCT,
  GET_PROD,
  GET_STORE,
  INSERT_PURCHASE_REQ,
  INSERT_PURCHASE_ORDEDR,
  PO_SEND_TO_SUPPLIER,
  GET_CATEGORIES,
  GET_CUSTOMERS,
  GET_VARIANT,
  PROD_DOWNLD_EXCEL,
  PRODUCT_DOWNLOD_EXCEL,
  PRODUCT_UPLOAD_EXCEL,
  PRODUCT_EDIT_UPLOAD_EXCEL,
  PRODUCT_EDIT_DOWNLOD_EXCEL,
  GET_PURCHASE_REQ_DETAILS,
  GET_USER_STORES,
  GET_POS_TERMINALS,
  GET_CATEGORIES_ITEMS,
  GET_METAL_RATES,
  GET_ORDER_VIEW,
  GET_TRANSFER_PROD,
  GET_STOCK_TRANSFER_BY_ID,
  INSERT_TRANSFER_STOCK,
  INSERT_TRANSFER_STOCK_DETAILS,
  UPDATE_TRANSFER_STOCK_STATUS,
  GET_DASHBOARD_COUNT,
  GET_DASHBOARD_TABLES_DATA,
  GET_ACCOUNTS_DASHBOARD,
  GET_STORE_DASHBOARD,
  GET_TOP_SALES,
  GET_EXPENSE_TYPE,
  GET_EXPENSE,
  INSERT_EXPENSE,
  GET_SUB_CATEGORIES,
  INSERT_PROD,
  INSERT_STORE_PROD,
  GET_BRAND,
  DEL_BRAND,
  DEL_CATEGORY,
  UPDATE_SUB_CATEGORIES,
  GET_EXPIRED,
  GET_VSTORE_PROD,
  GET_VSTORE_POS_PROD,
  DEL_SUB_CATEGORY,
  GET_UNITS,
  DEL_UNITS,
  SIGN_IN_DETAILS,
  GET_INVOICE_PAYMENTS,
  GET_PAYMENTS_TYPES,
  ADD_PAYMENTS,
  GET_SUPPLIERS,
  GET_STOCK_INDENT,
  GET_STOCK_INDENT_LIST,
  GET_APPROVED_INDENTS_BY_STORE,
  INSERT_STOCK_INDENT,
  DOWNLD_EXCEL,
  UPLOAD_EXCEL,
  PO_UPLOAD_EXCEL,
  GET_APPROVED_INDENTS,
  GET_CONSOLIDATED_INDENTS,
  GET_PURCHASE_REQ,
  GET_PO,
  GET_INVOICES,
  GET_TRANSFER_STOCK,
  GET_PO_RECEIVED_BY_ID,
  GET_PO_REQ_BY_ID,
  INSERT_PURCHASE_INVOICE,
  GET_PO_BY_ID,
  GET_SUP_STO_DATA,
  INSERT_POS_TERMINALS,
  UPDATE_POS_TERMINALS,
};
